import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AffiliationGuardService } from './core/gaurds/affiliation-guard.service';

const routes: Routes = [
  {
    path: '',
    canActivate: [AffiliationGuardService],
    children: [],
  },
  {
    path: 'static',
    loadChildren: () =>
      import('./static/static.module').then((m) => m.StaticModule),
  },
  {
    path: 'general',
    loadChildren: () =>
      import('./portals/general/general.module').then((m) => m.GeneralModule),
  },
  {
    path: 'auth',
    loadChildren: () => import('./auth/auth.module').then((m) => m.AuthModule),
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule { }
